import { dataCheckDesktop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheckDesktop = /*#__PURE__*/createIcon(dataCheckDesktop)
export default IconCheckDesktop
